module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Regular-4bdfc6f1af525ad5b0a68e3f5cfc6d8d.woff";